import { ORG_APIS } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { ILabReportLabPartnerResponse } from "@/api_framework/api_modals/LabReport";

AxiosCurlirize(axios, () => {});

export const useClinicListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const [clinicList, setClinicList] = useState([]);

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(ORG_APIS?.CLINIC_LIST_API?.baseURL ?? "", {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<ILabReportLabPartnerResponse>) => {
          if (res.data.status === true) {
            setClinicList(res.data.data);
          } else {
            setClinicList([]);
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          captureError(e);
          setClinicList([]);
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
      setClinicList([]);
    }
  }, [dispatch]);
  return { execute, clinicList };
};
